const ProductHeader = ({productName, referenceCode}) => {
  return (
    <div className="flex-grow-1 upper-row">
      <span className="fs-14 heading_1">{productName}</span>
      <div>
        <span className="heading_6 labels-tags">Ref:</span>
        <span className="bodyText_7 ref-text mt-1">{referenceCode}</span>
      </div>
    </div>
  )
}

export default ProductHeader
